import { render } from "./video-player.vue?vue&type=template&id=a96f8328&scoped=true"
import script from "./video-player.vue?vue&type=script&lang=js"
export * from "./video-player.vue?vue&type=script&lang=js"

import "./video-player.vue?vue&type=style&index=0&id=a96f8328&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a96f8328"]])

export default __exports__